module.exports = __webpack_public_path__ + "static/media/ic_payment_notice.b98297be.png";